import actionTypes from 'SRC/modules/redux/actionTypes'

export const saveServiceProviderPhoto = photo => ({
  type: actionTypes.SAVE_SERVICE_PROVIDER_PHOTO,
  payload: photo
})
